// © 2026 Orpyx Medical Technologies Inc.

import {ICarePractitionerActionDto, IPrimaryConcernDto} from "doctors-dashboard/http-clients/index";

/// <summary>
/// <para>The concerns the selected action offers, empty when it offers none.</para>
/// <para>An empty list is what hides the field, and the API applies the same rule when deciding
/// whether a primary concern is required, so both sides stay in agreement.</para>
/// </summary>
export const primaryConcernsForAction = (actions: ICarePractitionerActionDto[], actionId: string | undefined): IPrimaryConcernDto[] => {
    if (!actionId)
        return [];

    const selectedActionId = parseInt(actionId, 10);
    if (isNaN(selectedActionId))
        return [];

    return actions.find(action => action.id === selectedActionId)?.primaryConcerns ?? [];
};
